import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import {
  centsToDollars,
  dateToTimestamp,
  dollarsToCents,
  timestampToDate,
} from '../../../utils/fieldNormalizers';

/** @typedef { import('./_types').ClockEntry } ClockEntry */

/** @type {(entry: any) => ClockEntry} */
export function normalizeClockEntry(entry) {
  let normalized = camelcaseKeys(entry, { deep: true });

  return {
    ...normalized,
    endDate: timestampToDate(normalized.endDate),
    startDate: timestampToDate(normalized.startDate),
    payrate: centsToDollars(normalized.payrate),
    pay: centsToDollars(normalized.pay),
  };
}

export function normalizeClockEntryAggregates(aggregates) {
  let normalized = camelcaseKeys(aggregates, { deep: true });
  return {
    ...normalized,
    averagePayrate: centsToDollars(normalized.averagePayrate),
    totalPay: centsToDollars(normalized.totalPay),
  };
}

/** @type {(visit: Partial<ClockEntry>) => any} */
export function denormalizeClockEntry(entry) {
  if (entry.payrate) {
    entry.payrate = dollarsToCents(entry.payrate);
  }

  const obj = decamelizeKeys(entry, { deep: true });

  return {
    ...obj,
    start_date: dateToTimestamp(entry.startDate),
    end_date: dateToTimestamp(entry.endDate),
  };
}
